const de = {
  a11yVideoLabelText: "Video zeigt die Überprüfung der Gesichtsvividenz",
  cameraMinSpecificationsHeadingText: "Minimale Kameraspezifikationen",
  cameraMinSpecificationsMessageText:
    "Bitte stellen Sie sicher, dass Ihre Kamera die Mindestanforderungen für die Vividenzüberprüfung erfüllt.",
  cameraNotFoundHeadingText: "Kamera nicht gefunden",
  cameraNotFoundMessageText:
    "Wir konnten keine Kamera erkennen. Bitte stellen Sie sicher, dass Ihre Kamera angeschlossen ist, und versuchen Sie es erneut.",
  cancelLivenessCheckText: "Vividenzüberprüfung abbrechen",
  clientHeaderText: "Kundenmeldung",
  clientMessageText:
    "Bitte folgen Sie den Anweisungen auf dem Bildschirm, um die Vividenzüberprüfung abzuschließen.",
  connectionTimeoutHeaderText: "Verbindungszeitüberschreitung",
  connectionTimeoutMessageText:
    "Die Verbindung ist abgelaufen. Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.",
  errorLabelText: "Fehler",
  faceDistanceHeaderText: "Gesichtsabstand",
  faceDistanceMessageText:
    "Bitte stellen Sie sicher, dass Ihr Gesicht den richtigen Abstand zur Kamera hat.",
  goodFitAltText: "Das Gesicht ist gut ausgerichtet",
  goodFitCaptionText:
    "Ihr Gesicht ist gut ausgerichtet. Bitte bleiben Sie still.",
  hintCanNotIdentifyText:
    "Gesicht kann nicht identifiziert werden. Bitte versuchen Sie es erneut.",
  hintCenterFaceInstructionText: "Zentrieren Sie Ihr Gesicht im Rahmen.",
  hintCenterFaceText: "Zentrieren Sie Ihr Gesicht",
  hintCheckCompleteText: "Überprüfung abgeschlossen",
  hintConnectingText: "Verbindet...",
  hintFaceDetectedText: "Gesicht erkannt",
  hintFaceOffCenterText: "Ihr Gesicht ist nicht zentriert. Bitte anpassen.",
  hintHoldFaceForFreshnessText:
    "Halten Sie Ihr Gesicht für die Überprüfung still.",
  hintIlluminationNormalText: "Die Beleuchtung ist gut",
  hintIlluminationTooBrightText: "Die Beleuchtung ist zu hell",
  hintIlluminationTooDarkText: "Die Beleuchtung ist zu dunkel",
  hintMatchIndicatorText: "Vergleicht Gesichtsindikatoren...",
  hintMoveFaceFrontOfCameraText: "Bewegen Sie Ihr Gesicht vor die Kamera",
  hintTooCloseText: "Sie sind zu nah an der Kamera",
  hintTooFarText: "Sie sind zu weit von der Kamera entfernt",
  hintTooManyFacesText:
    "Zu viele Gesichter erkannt. Es sollte nur ein Gesicht im Rahmen sein.",
  hintVerifyingText: "Überprüft...",
  landscapeHeaderText: "Querformatmodus erkannt",
  landscapeMessageText:
    "Bitte wechseln Sie für die Vividenzüberprüfung in den Hochformatmodus.",
  multipleFacesHeaderText: "Mehrere Gesichter erkannt",
  multipleFacesMessageText:
    "Es sollte nur ein Gesicht im Rahmen sein. Bitte anpassen und erneut versuchen.",
  photosensitivityWarningBodyText:
    "Diese Überprüfung beinhaltet eine Reihe von visuellen Reizen. Wenn Sie Probleme mit Lichtempfindlichkeit haben, gehen Sie vorsichtig vor.",
  photosensitivityWarningHeadingText: "Warnung vor Lichtempfindlichkeit",
  photosensitivityWarningInfoText:
    "Sie können die Überprüfung jederzeit abbrechen, wenn Sie Unbehagen verspüren.",
  photosensitivityWarningLabelText: "Ich verstehe die Risiken",
  portraitMessageText: "Bitte halten Sie Ihr Gerät im Hochformat.",
  recordingIndicatorText: "Aufnahme läuft",
  retryCameraPermissionsText: "Kameraberechtigungen erneut versuchen",
  serverHeaderText: "Serverproblem",
  serverMessageText:
    "Es gab ein Problem bei der Verbindung zum Server. Bitte versuchen Sie es später erneut.",
  startScreenBeginCheckText: "Vividenzüberprüfung starten",
  timeoutHeaderText: "Zeitüberschreitung",
  timeoutMessageText:
    "Der Vorgang ist abgelaufen. Bitte versuchen Sie es erneut.",
  tooFarAltText: "Das Gesicht ist zu weit von der Kamera entfernt",
  tooFarCaptionText: "Bitte näher an die Kamera heranrücken.",
  tryAgainText: "Erneut versuchen",
  waitingCameraPermissionText: "Warte auf Kameragenehmigung...",
};

export default de;
